import SectionHeading from '@/components/base/SectionHeading';
import PhaseBadge from '@/components/feature/PhaseBadge';
import { PHASES } from '@/mocks/schedule';
import { formatCnRange } from '@/utils/date';

export default function AgendaSection() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-100" aria-labelledby="agenda-heading">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          id="agenda-heading"
          eyebrow="Agenda"
          title="各阶段具体安排"
          desc="每个阶段要完成什么、什么时候结束，都写在对应卡片里。详细时间轴可以到赛程时间表页查看。"
        />

        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-5">
          {PHASES.map((p, idx) => (
            <article
              key={p.id}
              className="rounded-lg border border-background-200 bg-background-50 p-5 md:p-6 hover:border-primary-300 transition-colors"
            >
              <div className="flex items-center gap-3">
                <span className="w-8 h-8 flex items-center justify-center rounded-md bg-background-200 font-heading text-sm font-bold text-foreground-700">
                  {idx + 1}
                </span>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">{p.name}</h3>
                <span className="ml-auto">
                  <PhaseBadge status={p.status} />
                </span>
              </div>

              <p className="mt-3 text-xs md:text-sm font-medium text-primary-700">{formatCnRange(p.start, p.end)}</p>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{p.summary}</p>

              <p className="mt-4 flex items-start gap-2 text-sm text-foreground-700">
                <span className="w-4 h-4 shrink-0 flex items-center justify-center mt-1">
                  <i className="ri-flag-line text-secondary-500"></i>
                </span>
                {p.action}
              </p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}